var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-in-container__logo"},[_c('img',{attrs:{"aria-label":"Logo","src":this.localUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }